import React, { useEffect, useState } from 'react';
import { Overlay, Spinner } from '@flixbus/honeycomb-react';
import { useLoading } from '../../contexts/LoadingContext';

// Searches and Excel files can take minutes; after this time the loader says so.
const SLOW_MESSAGE_DELAY = 15 * 1000;

const Loader = () => {
    const { loading } = useLoading();
    const [showMessage, setShowMessage] = useState(false);

    useEffect(() => {
        if (!loading) return undefined;
        const timeout = setTimeout(() => setShowMessage(true), SLOW_MESSAGE_DELAY);
        return () => {
            clearTimeout(timeout);
            setShowMessage(false);
        };
    }, [loading]);

    if (!loading) return null;

    return (
        <Overlay extraClasses="loader" role="status" aria-label="Loading" aria-busy="true" aria-live="polite">
            <Spinner size="xl" extraClasses="loader__spinner" />
            {showMessage && <p className="loader__message">This process takes a while. Please wait...</p>}
        </Overlay>
    );
};

export default Loader;
